export const COOKIE_NAME = 'MOBILE_PASSWORD_AUTHENTICATED';
